// extracted by mini-css-extract-plugin
module.exports = {"itemView":"ContractItem_itemView__3vmTw","signer":"ContractItem_signer__3EJTm","bold":"ContractItem_bold__2XBss","img":"ContractItem_img__2WqLI"};